export const LIVING_TRUTH_SECTION = {
  TITLE: 'A Living Truth',

  PARAGRAPH_1:
    'At Nirva, we hold a simple truth: A peaceful mind is the most valuable gift a human can\ncarry. It is the true currency of life—restoring clarity, resilience, and love in every\ndimension of being.',

  PARAGRAPH_2:
    'We believe that hypnotherapy, practiced ethically and relationally, is one of the most\ndirect ways to return to this peace.',

  PARAGRAPH_3:
    'Through the lineage of IIH, the network of IAIH-certified practitioners, and the living\nengine of Nirva, we affirm that transformation is not only possible—it is natural when\nthe mind is gently guided back to its source.',

  EMPHASIS_TEXT:
    '"Healing is not fixing, but remembering — the quiet shift within, the heart reopening, the mind returning to truth."',

  BUTTON_LABEL: 'Explore Our Services',
};
